import { createContext, useContext } from 'react';
import { InputCheckboxVariants } from './input_checkbox.component';

interface InputCheckboxGroupContextProps {
	name?: string;
	variant: InputCheckboxVariants;
	invalid: boolean;
	readOnly: boolean;
	disabled: boolean;
	values: string[];
}

export const InputCheckboxGroupContext = createContext<InputCheckboxGroupContextProps>(
	undefined as unknown as InputCheckboxGroupContextProps,
);

export function useInputCheckboxGroupContext(): InputCheckboxGroupContextProps {
	return useContext(InputCheckboxGroupContext);
}
